import * as React from "react";
import Config from "../../Config";

import iconClose from '../../../assets/icons/close.svg'
import iconCorner from '../../../assets/icons/corner-down-right.svg'

import WordInsertions from "../../utils/WordInsertions";
import ModalComponent from "./ModalComponent";
import ObjectsTree from "../ObjectsTree";
import AttrTree from "../AttrTree";
import FilterCheckNotebook from "../filters/FilterCheckNotebook";
import MetamodelStore from "../../resources/data/MetamodelStore";

import StateGlobal from "../../StateGlobal";

import tableIcon from '../../../assets/icons/table-list.svg'
import ModalTableAttrsRel from "./ModalTableAttrsRel.jsx";
import JsonTreeDataCreator from "../../utils/JsonTreeDataCreator.js";
import ModalTableObjAttrs from "./ModalTableObjAttrs.js";
import ModalTableObjAttrsRel from "./ModalTableObjAttrsRel.jsx";
import FilterDropDown from "../filterDropDown/FilterDropDown.jsx";

export default class ModalRelationData extends ModalComponent
{
    constructor(props)
    {
        super(props);
        this.state = {
            notebook: null,
            targetClassesNotebooks: null,
            targetModeltypesNotebooks: null,
            direction: "",
            relationName: "",
            relationNameLang: "",
            filterSelection: [],
            pairMode: false,
            displayError: false,
            errorMessageDefault: "Error!",
            errorMessage: "",
            modalAttrRelIsOpen: false,
            modalTableObjectsIsOpen: false,
            currentTableNotebook: {},
            typeRel: "",
            loopTargets: []
        }

        this.aModalFilter = React.createRef();
        this.aModalFilterNotebook = React.createRef();
    }

    setNotebook = (aNotebook) =>
    {
        this.state.notebook = aNotebook;
    }
    setTargetModeltypesNotebooks = (aNotebooks) =>
    {
        this.state.targetModeltypesNotebooks = aNotebooks;
    }
    setTargetClasssesNotebooks = (aNotebooks) =>
    {
        this.state.targetClassesNotebooks = aNotebooks;
    }

    setTypeRel = (type) => {
        this.state.typeRel = type
    }

    setDirection = (sDirection) =>
    {
        this.state.direction = sDirection;
    }
    setRelationName = (sName) =>
    {
        this.state.relationName = sName;
        this.state.relationNameLang = Config.getLangName(Object.values(MetamodelStore.getInstance().getRelations()).find(aRel =>
        {
            return aRel.sName === sName;
        }));
    }

    setFilterSelectionTarget = () =>
    {
        let aSelectionTarget = this.aModalFilter.current ? this.aModalFilter.current.getSelection() : [];
        let aSelectionNotebook = this.aModalFilterNotebook.current ? this.aModalFilterNotebook.current.getSelection() : [];
        aSelectionTarget.forEach(aSelect =>
        {
            if (aSelect.hasOwnProperty("extra"))
            {
                aSelect.extra["relation"] = this.state.relationName;
                aSelect.extra["relationLang"] = this.state.relationNameLang;
                aSelect.extra["isTarget"] = true;
                aSelect.extra["direction"] = this.state.direction;
            }
        });
        aSelectionNotebook.forEach(aSelect =>
        {
            if (aSelect.hasOwnProperty("extra"))
            {
                aSelect.extra["relation"] = this.state.relationName;
                aSelect.extra["relationLang"] = this.state.relationNameLang;
                aSelect.extra["direction"] = this.state.direction;
            }
        });
        let aSelection = aSelectionTarget.concat(aSelectionNotebook);
        this.state.filterSelection = aSelection;
    }

    validateSelections = () =>
    {
        if (this.state.pairMode)
        {
            let aSelectionTarget = this.aModalFilter.current ? this.aModalFilter.current.getSelection() : [];
            let aSelectionNotebook = this.aModalFilterNotebook.current ? this.aModalFilterNotebook.current.getSelection() : [];
            if (!(aSelectionTarget && 1 === aSelectionTarget.length && aSelectionNotebook && 1 === aSelectionNotebook.length))
            {
                return false;
            }
        }
        return true;
    }

    getFilterSelection = () =>
    {
        let bIsValidationOk = this.validateSelections();
        if (!bIsValidationOk)
        {
            return [];
        }
        if (!this.state.pairMode)
        {
            return this.state.filterSelection;
        } else
        {
            let aSelectionTarget = this.aModalFilter.current ? this.aModalFilter.current.getSelection() : [];
            let aSelectionNotebook = this.aModalFilterNotebook.current ? this.aModalFilterNotebook.current.getSelection() : [];
            return [{
                isPair: true,
                name: [this.state.relationName, aSelectionNotebook[0].name, aSelectionTarget[0].name].join("#"),
                attrs: this.state.filterSelection,
                relation: this.state.relationName,
                relationLang: this.state.relationNameLang
            }];
        }
    }

    switchSelectionMode = (aEvent) =>
    {
        if (aEvent.target)
        {
            switch (aEvent.target.name)
            {
                case "modal_selection_data_pair_off":
                    this.state.pairMode = false;
                    this.setState({});
                    break;
                case "modal_selection_data_pair_on":
                    this.state.pairMode = true;
                    this.setState({});
                    break;
            }
        }
    }

    closeAttrRelModal = (prop) => {
        this.setState((prevState) => ({
            ...prevState,
            modalAttrRelIsOpen: !prevState.modalAttrRelIsOpen
        }));
    }
    closeObjectRelModal = (prop) => {
        this.setState((prevState) => ({
            ...prevState,
            modalTableObjectsIsOpen: !prevState.modalTableObjectsIsOpen
        }));
    }

    getJsonTreeModelProp = (sTopLvlLabel, isSuper) =>
        {
          if (Object.hasOwnProperty.call(this.state.aSelectedMetaModelTypeData, 'notebookStructure') || isSuper)
          {
            var aJsonTreeData = (isSuper
              ? JsonTreeDataCreator.superNotebookData('modeltypes', null, true)
              : JsonTreeDataCreator.notebookData(this.state.aSelectedMetaModelTypeData.notebookStructure, true));
      
            if (sTopLvlLabel)
            {
              return {
                [sTopLvlLabel]: aJsonTreeData
              };
            }
            return aJsonTreeData;
          }
          return null;
        }

    getTargets = (aTargets) => {
        const names = aTargets.map(target => target.name);
        this.setState({ targetNames: names });
    }

    render()
    {
        let aNotebook = this.state.notebook;
        let aTargetClassesNotebooks = this.state.targetClassesNotebooks;
        let aTargetModeltypesNotebooks = this.state.targetModeltypesNotebooks;
        const sRelationName = this.state.relationName;
        const sRelationNameLang = this.state.relationNameLang;
        const sTitleNotebook = this.props.titleNotebook;
        const sTitleModeltypes = this.props.titleModeltypes;
        const sTitleClasses = this.props.titleClasses;
        const bInnerLoop = this.props.innerLoop;
        const bIsFilter = this.props.isFilter;
        const selectionCallback = this.props.selectionCallback;
        const bPreventRelationNotebook = this.props.preventRelationNotebook;
        const bPairModeAllowed = this.props.pairModeAllowed;
        const aAllObjects = this.props.allObjects;
        const aAllModels = this.props.allModels;
        const aAdoVersion = JSON.parse(localStorage["ado_version"]);
        const bHideLoop = this.props.hideLoop;
        const sRestVersion = (
            aAdoVersion && aAdoVersion.hasOwnProperty("rest_version") && aAdoVersion.rest_version
        ) ?
            aAdoVersion.rest_version :
            null;

        // console.log("aNotebook", aNotebook);
        // console.log("aTargetClassesNotebooks", aTargetClassesNotebooks);
        // console.log("aTargetModeltypesNotebooks", aTargetModeltypesNotebooks);
        // console.log("bIsFilter", bIsFilter);
        // console.log("sRelationName", sRelationName);
        // console.log("bPreventRelationNotebook", bPreventRelationNotebook);
        // console.log("sRestVersion", sRestVersion);
        // console.log("aNotebook", aNotebook);
        // console.log("aTargetModeltypesNotebooks", aTargetModeltypesNotebooks)
        // console.log("aTargetClassesNotebooks", aTargetClassesNotebooks)
        // console.log("sRelationName", sRelationName)

        if (!this.state.openModal)
        {
            this.state.pairMode = false;
        }

        const breadcrumbsData = StateGlobal._currentBradCrumbs
        let spacing = -15;
        return (
            this.state.openModal ?
            <div className="popup">
                <div className="popup__container">
                    <div className="popup__header">
                        <h1 className="popup__title"></h1>
                        <button className="popup__close-btn" onClick={()=>{
                            StateGlobal._currentBradCrumbs.pop();
                            this.state.displayError = false;
                            this.toggleModal();
                        }}>
                            <img src={iconClose}/>
                        </button>
                    </div>
                    <div className="popup__content">
                    {StateGlobal._currentBradCrumbs.length > 0 && <div className="popup__section">
                        {
                            <ul>
                                <li style={{
                                    fontSize: "12px",
                                    paddingLeft: spacing+"px"
                                }}>

                                    {StateGlobal._isModelSelected && StateGlobal._modelSelected}
                                    {StateGlobal._isObjectSelected && StateGlobal._objectSelected}

                                </li>
                                {
                                    breadcrumbsData.map((item,key)=>{
                                        spacing+=15;
                                        return (
                                            <li style={{
                                                fontSize: "12px",
                                                paddingLeft: spacing+"px"
                                            }} key={key}>{<img src={iconCorner} height={12}/>}{item}</li>
                                        )
                                                                                
                                    })
                                }
                            </ul>
                        }
                    </div>}
                    {StateGlobal._currentBradCrumbs.length > 0 && <div className="popup__section">
                    {/* <div className="wrcFilter_container">
                    <button className="wrcButton wrcButton--dark" onClick={()=>{

                    const currentLvl = StateGlobal._currentBradCrumbs.length;
                    const prevLvl = currentLvl - 1;

                    if(currentLvl <= 1){
                        WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR lvl_"+currentLvl+" in getArtefactFromRelation($element, '" + sRelationName+":"+StateGlobal._currentRelDirection + "')" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR lvl_"+currentLvl + WordInsertions.aDelimiters.sEnd);

                    }else{
                        WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR lvl_"+currentLvl+" in getArtefactFromRelation("+"$lvl_"+prevLvl+", '" + sRelationName+":"+StateGlobal._currentRelDirection + "')" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR lvl_"+currentLvl + WordInsertions.aDelimiters.sEnd);
                    }


                    }}>For each  {sRelationNameLang} (loop)</button>
                    </div> */}
                    <div className="button-group">
                    <button className="btn btn--dark btn--full" onClick={() => {
                        const currentLvl = StateGlobal._currentBradCrumbs.length;
                        const prevLvl = currentLvl - 1;

                        const namesArrayString = JSON.stringify(this.state.targetNames);

                        if (currentLvl <= 1) {
                            WordInsertions.insertText(
                                WordInsertions.aDelimiters.sStart +
                                "FOR lvl_" + currentLvl + " in getArtefactFromRelation($element, '" + sRelationName + ":" + StateGlobal._currentRelDirection + "'," + namesArrayString + ")" +
                                WordInsertions.aDelimiters.sEnd + "\n\n" +
                                WordInsertions.aDelimiters.sStart + "END-FOR lvl_" + currentLvl + WordInsertions.aDelimiters.sEnd
                            );
                        } else {
                            WordInsertions.insertText(
                                WordInsertions.aDelimiters.sStart +
                                "FOR lvl_" + currentLvl + " in getArtefactFromRelation($lvl_" + prevLvl + ", '" + sRelationName + ":" + StateGlobal._currentRelDirection + "'," + namesArrayString + ")" +
                                WordInsertions.aDelimiters.sEnd + "\n\n" +
                                WordInsertions.aDelimiters.sStart + "END-FOR lvl_" + currentLvl + WordInsertions.aDelimiters.sEnd
                            );
                        }
                    }}>For each {sRelationNameLang} (loop)</button>
                        {(aTargetClassesNotebooks && 0 < Object.keys(aTargetClassesNotebooks).length ? <FilterDropDown getTargets={this.getTargets} data={aTargetClassesNotebooks}/> : "")}
                        {(aTargetModeltypesNotebooks && 0 < Object.keys(aTargetModeltypesNotebooks).length ? <FilterDropDown getTargets={this.getTargets} data={aTargetModeltypesNotebooks}/> : "")}
                    </div>
                    {(aTargetModeltypesNotebooks && 0 < Object.keys(aTargetModeltypesNotebooks).length) && <button className="wrcButton" onClick={WordInsertions.modelImage}>Insert model graphic</button>}
                    </div>}
                    <div className="popup__section">
                    {
                                (!bPreventRelationNotebook && aNotebook && 0 < Object.keys(aNotebook).length) ?
                                    <div>
                                        {
                                            (sRestVersion === "2.1") ?
                                                <div>
                                                    {
                                                        bPairModeAllowed ?
                                                            <div>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        checked={!this.state.pairMode}
                                                                        onChange={this.switchSelectionMode}
                                                                        name={"modal_selection_data_pair_off"}
                                                                    />
                                                                    <label>{Config.strings.modals.relationData.pairModeOff}</label>
                                                                </div>
                                                                <div>
                                                                    <input
                                                                        type="radio"
                                                                        checked={this.state.pairMode}
                                                                        onChange={this.switchSelectionMode}
                                                                        name={"modal_selection_data_pair_on"}
                                                                    />
                                                                    <label>{Config.strings.modals.relationData.pairModeOn}</label>
                                                                </div>
                                                            </div> :
                                                            null
                                                    }

                                                    <h4 className="Modal__label">
                                                        {sTitleNotebook.concat(":")}
                                                    </h4>
                                                    {bIsFilter ?
                                                        <>
                                                        <FilterCheckNotebook
                                                            aNotebook={aNotebook}
                                                            bIsModelObj={bInnerLoop}
                                                            isNested={true}
                                                            ref={this.aModalFilterNotebook}
                                                            onChangeCallback={this.setFilterSelectionTarget.bind(this)}
                                                            singleSelection={this.state.pairMode}
                                                        />
                                                        </> :
                                                        <>
                                                        <AttrTree
                                                            typeOfRel={this.state.typeRel}
                                                            treeData={aNotebook}
                                                            dataType={"relation"}
                                                            isNested={true}
                                                            direction={this.state.direction}
                                                            isInnerLoop={bInnerLoop}
                                                            relationName={sRelationName}
                                                        />
                                                        </>
                                                    }
                                                </div> :
                                                <h4 className="Modal__label">
                                                    {Config.strings.modals.relationData.adoVersionIssue}
                                                </h4>
                                        }
                                    </div> :
                                    null
                            }

                            {
                                (aTargetClassesNotebooks && 0 < Object.keys(aTargetClassesNotebooks).length) ?
                                    <div>
                                        <h4 className="Modal__label">
                                            {sTitleClasses.concat(":")}
                                        </h4>
                                        {
                                            bIsFilter ?
                                                <FilterCheckNotebook
                                                    aNotebook={aTargetClassesNotebooks}
                                                    bIsModelObj={bInnerLoop}
                                                    isNested={true}
                                                    // direction={this.state.direction}
                                                    // isInnerLoop={bInnerLoop}
                                                    ref={this.aModalFilter}
                                                    onChangeCallback={this.setFilterSelectionTarget.bind(this)}
                                                    singleSelection={this.state.pairMode}
                                                /> :
                                                <ObjectsTree
                                                    typeOfRel={this.state.typeRel}
                                                    treeData={aTargetClassesNotebooks}
                                                    isNested={true}
                                                    direction={this.state.direction}
                                                    isInnerLoop={bInnerLoop}
                                                    relationName={sRelationName}
                                                    
                                                />
                                        }
                                    </div> :
                                    null
                            }

                            {
                                (aTargetModeltypesNotebooks && 0 < Object.keys(aTargetModeltypesNotebooks).length) ?
                                    <div>
                                        <h4 className="Modal__label">
                                            {sTitleModeltypes.concat(":")}
                                        </h4>
                                        {
                                            (bIsFilter) ?
                                                <FilterCheckNotebook
                                                    aNotebook={aTargetModeltypesNotebooks}
                                                    bIsModelObj={bInnerLoop}
                                                    isNested={true}
                                                    // direction={this.state.direction}
                                                    // isInnerLoop={bInnerLoop}
                                                    ref={this.aModalFilter}
                                                    onChangeCallback={this.setFilterSelectionTarget.bind(this)}
                                                    singleSelection={this.state.pairMode}
                                                /> :
                                                <AttrTree
                                                    typeOfRel={this.state.typeRel}
                                                    treeData={aTargetModeltypesNotebooks}
                                                    dataType="models"
                                                    isNested={true}
                                                    direction={this.state.direction}
                                                    isInnerLoop={bInnerLoop}
                                                    relationName={sRelationName}
                                                    isTarget={true}
                                                />
                                        }
                                    </div> :
                                    null
                            }

                            {
                                (this.state.displayError) ?
                                    <h4 className="App__errorMessage" >
                                        {this.state.errorMessage ? this.state.errorMessage : this.state.errorMessageDefault}
                                    </h4> :
                                    null
                            }
                            {
                                selectionCallback ?
                                    <button className="wrcButton wrcButton--confirm" onClick={() =>
                                    {
                                        let bValidationOk = this.validateSelections();
                                        if (bValidationOk)
                                        {
                                            selectionCallback();
                                            this.toggleModal();
                                            StateGlobal._currentBradCrumbs.pop();
                                        } else
                                        {
                                            this.setState({
                                                displayError: true,
                                                errorMessage: Config.strings.errorMessages.relationData.pairModeSelectionMissing
                                            });
                                        }
                                    }}>
                                        {Config.strings.modals.relationData.sConfirmLabel}
                                    </button> :
                                    null
                            }
                    </div>
                    <div className="popup__section">
                        <ModalTableAttrsRel
                            aNotebook={this.state.currentTableNotebook || {}}
                            isOpen={this.state.modalAttrRelIsOpen || false}
                            onClose={this.closeAttrRelModal}
                        />
                        <ModalTableObjAttrsRel
                            aItems={aAllObjects || {}}
                            isOpen={this.state.modalTableObjectsIsOpen}
                            onClose={this.closeObjectRelModal}
                        />
                        {(aTargetModeltypesNotebooks && 0 < Object.keys(aTargetModeltypesNotebooks).length) && StateGlobal._currentBradCrumbs.length > 0 &&
                        <>
                        <button className="wrcButton wrcButton--secondary" onClick={async ()=>{
                            {

                                const aModels = JsonTreeDataCreator.superNotebookData('modeltypes', null, true);
                                
                                const aFilteredModels = Object.keys(aModels)
                                .filter(key => aAllModels.includes(key))
                                .reduce((obj, key) => {
                                    obj[key] = aModels[key];
                                    return obj;
                                }, {});

                                this.setState((prevState) => ({
                                    ...prevState,
                                    modalAttrRelIsOpen: !this.state.modalAttrRelIsOpen,
                                    currentTableNotebook: aFilteredModels
                                  }));

                            }
                        }}>
                            <img src={tableIcon} height={24}/>
                            {Config.strings.buttonLabels.insertTableModelAttr}
                        </button>
                        <button className="wrcButton wrcButton--secondary wrcButton--secondary_icon" onClick={async ()=>{
                            {

                                this.setState((prevState) => ({
                                    ...prevState,
                                    modalTableObjectsIsOpen: !this.state.modalTableObjectsIsOpen,
                                    currentTableNotebook: aAllObjects
                                  }));

                            }
                        }}>
                            <img src={tableIcon} height={24}/>
                            {Config.strings.buttonLabels.insertModelObj}
                        </button>
                        </>
                        }
                        {(aTargetClassesNotebooks && 0 < Object.keys(aTargetClassesNotebooks).length) && StateGlobal._currentBradCrumbs.length > 0 &&
                        <>
                        <button className="wrcButton wrcButton--secondary wrcButton--secondary_icon" onClick={async ()=>{
                            {
                                this.setState((prevState) => ({
                                    ...prevState,
                                    modalAttrRelIsOpen: !this.state.modalAttrRelIsOpen,
                                    currentTableNotebook: aTargetClassesNotebooks
                                  }));

                            }
                        }}>
                            <img src={tableIcon} height={24}/>
                            {Config.strings.buttonLabels.insertTableObjAttr}
                        </button>
                        </>}
                        
                    </div>
                    </div>
                    <div className="popup__footer">
                        <button className="popup__close-btn" onClick={()=>{
                            StateGlobal._currentBradCrumbs.pop();
                            this.state.displayError = false;
                            this.toggleModal();
                        }}>Close</button>
                    </div>
                </div>
            </div>
                :
                null
        );
    }
}